/*
 ########  #######     ###     ######  ########
    ##    ##     ##  ##   ##  ##          ##
    ##    ##     ## ##     ##  ######     ##
    ##    ##     ## #########       ##    ##
    ##     #######  ##     ##  ######     ##
トースト通知処理
<div id="js-toast" class="toast"></div>
window.popToast('テキスト')
*/

const toast = document.getElementById('js-toast') // トースト要素
let isPopToast = false // トーストの出現フラグ
window.popToast = function (text = '', wait = 3000) {
  if (!toast) {
    // トースト要素の存在確認
    return
  }
  if (text === '') {
    // テキストが空
    return
  }
  toast.innerHTML = text // テキストをセット
  toast.classList.add('active')
  if (!isPopToast) {
    isPopToast = true
    setTimeout(() => {
      toast.classList.remove('active')
      isPopToast = false
    }, wait)
  }
}
